import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from "./shared/shared.module";
import {AppSecurityModule} from "./security/app-security.module";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AbstractLoggerService, AuthInterceptor} from "angular-auth-oidc-client";
import {LogService} from "./auth/log.service";
import {FormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AuthConfigModule} from "./auth/auth-config.module";
import {LayoutComponent} from "./layout/layout.component";
import {AppVersionComponent} from "./shared/commons/app-version/app-version.component";

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    AppVersionComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AuthConfigModule,
    AppSecurityModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: AbstractLoggerService, useClass: LogService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
